export default "__VITE_ASSET__Dvp8lN7H__"